import request from "./request";
import apis from "./apis";

const {
  classTimePeriodInfos,
  classTimePeriodInfo,
} = apis.classTimePeriod;

const classTimePeriod = {
  getClassTimePeriods: (data: Object) => {
    return request.get(classTimePeriodInfos, data);
  },
  createClassTimePeriod: (data: Object) => {
    return request.post(classTimePeriodInfo, data);
  },
  updateClassTimePeriod: (data: Object) => {
    return request.put(classTimePeriodInfo, data);
  },
  deleteClassTimePeriod: (data: Object) => {
    return request.delete(classTimePeriodInfo, data);
  },
};

export default classTimePeriod;